import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  ref: "endOfPageRef",
  height: "1px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ArticleCard = _resolveComponent("ArticleCard")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Grid, { size: "xl" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trans("general.news")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Row, {
          gap: "xl",
          class: "-mt-md"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
              return (_openBlock(), _createBlock(_component_Col, {
                size: ['1/1', '1/2@md', '1/3@lg'],
                key: article._id
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_ArticleCard, {
                    key: article._id,
                    article: article
                  }, null, 8, ["article"]))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.hasNextPage && _ctx.isFetchingNextPage)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, null, 512)
  ]))
}